<template>
  <div class="btn-player" @click="activeCurrentPodcast">
    <TagLock class="btn-player__lock" v-if="!hasPaidAccount && !isAuthenticated" />
    <div class="btn-player__play">
      <PlayIcon class="btn-player__play-icon"/>
    </div>
    <SkeletItem class="btn-player__skeleton" :height="20" v-if="isInitializing" />
    <span class="btn-player__txt" v-else>{{ btnText }}</span>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useUserAuth } from '@/Groups/Audioplayer/private/imports/externalStoreData';
  import { useAudioPlayerState } from '@/Groups/Audioplayer/private/composables/computedValues';
  import { formatTime_dnum_mn, formatTime_dn_mn} from '@/Groups/Audioplayer/private/imports/externalUtils';
  import { useScreenSize } from '@/Groups/Audioplayer/private/imports/screenSize';
  //--------------------------
  import PlayIcon from '@/Groups/Audioplayer/private/svg/PlayIcon.vue';
  import { SkeletItem, TagLock } from "@/Groups/Audioplayer/private/imports/externalTemplates";
  //--------------------------
  const { podcast, isInitializing } = useAudioPlayerState();
  //--------------------------
  const { isAuthenticated, hasPaidAccount } = useUserAuth();
  //--------------------------
  const { screenWidth } = useScreenSize();
  //--------------------------
  const btnText = computed(() => {
    const time = podcast.value?.publication_date || new Date();
    return (screenWidth.value > 1023 && screenWidth.value < 1050 ||screenWidth.value < 350) ? 
      formatTime_dn_mn(time) : formatTime_dnum_mn(time);
  });
</script>

<style scoped lang="scss">
  @import "./styles.scss";
</style>